import { routesWithPerms, groupPermissions } from '../components/Shared/Main';

export function isEnoughPermissions(item, currentUserPerms) {
    const perms = []
        .concat(...routesWithPerms.filter(route => route.path.includes(item.routeTo)).map(route => route.perm))
        .filter((value, index, self) => self.indexOf(value) === index);
    return perms.some(perm => currentUserPerms.includes(perm.value));
}

export function calcCurrentPerms(permissions) {
    const userAssignedRoles = permissions || [];
    const allPerms = Object.values(groupPermissions);

    const arrayWithPerms = [];
    userAssignedRoles.forEach(userAssignedRole =>
        allPerms.some(perm => {
            if (userAssignedRole === perm.value) {
                arrayWithPerms.push(perm);
                return true;
            } else return false;
        })
    );

    return arrayWithPerms;
}
